import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
	uploadSignatureFile,
	setUserSignature,
} from '@dealstack/frontend/shared/dataExchange/services/god.service';
import { SAVED_SIGNATURE_QUERY_KEY } from './useSavedSignature';

const dataUrlToBlob = async (dataUrl: string): Promise<Blob> => {
	const response = await fetch(dataUrl);
	return response.blob();
};

export const useSaveUserSignature = () => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: async (dataUrl: string): Promise<string> => {
			const blob = await dataUrlToBlob(dataUrl);
			const uploadResponse = await uploadSignatureFile(blob);
			const fileId = uploadResponse?.payload?.id;
			if (!fileId) {
				throw new Error('Signature upload returned no file id');
			}
			await setUserSignature(fileId);
			return fileId;
		},
		onSuccess: () => {
			return queryClient.invalidateQueries({ queryKey: SAVED_SIGNATURE_QUERY_KEY });
		},
	});
};
